class CstmAnnouncementContactBar extends HTMLElement {
  connectedCallback() {
    this.mobileMediaQuery = window.matchMedia("(max-width: 749px)");
    this.handleViewportChange = () => this.updateStatus();
    this.mobileMediaQuery.addEventListener("change", this.handleViewportChange);
    this.updateStatus();
    this.statusInterval = window.setInterval(() => this.updateStatus(), 60000);
  }

  disconnectedCallback() {
    if (this.statusInterval) {
      window.clearInterval(this.statusInterval);
    }

    if (this.mobileMediaQuery && this.handleViewportChange) {
      this.mobileMediaQuery.removeEventListener("change", this.handleViewportChange);
    }
  }

  getBerlinTime() {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: this.dataset.timeZone || "Europe/Berlin",
      weekday: "short",
      hour: "2-digit",
      hourCycle: "h23",
    });
    const parts = formatter.formatToParts(new Date());
    const weekday = parts.find((part) => part.type === "weekday")?.value;
    const hour = Number(parts.find((part) => part.type === "hour")?.value);
    const weekdayIndexes = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6,
    };

    return {
      day: weekdayIndexes[weekday],
      hour,
    };
  }

  isAllowedDay(day) {
    const configuredDays = this.dataset.availabilityDays;

    if (configuredDays === "everyday") return true;
    if (configuredDays === "weekdays") return day >= 1 && day <= 5;
    if (configuredDays === "mo-sa") return day >= 1 && day <= 6;
    if (configuredDays === "weekend") return day === 0 || day === 6;

    return false;
  }

  isAvailable() {
    const { day, hour } = this.getBerlinTime();
    const startHour = Number(this.dataset.availabilityStart);
    const endHour = Number(this.dataset.availabilityEnd);

    if (!Number.isInteger(day) || !Number.isFinite(hour)) return false;
    if (!Number.isFinite(startHour) || !Number.isFinite(endHour)) return false;

    if (startHour < endHour) {
      return this.isAllowedDay(day) && hour >= startHour && hour < endHour;
    }

    if (startHour > endHour) {
      const previousDay = (day + 6) % 7;
      return (
        (this.isAllowedDay(day) && hour >= startHour) ||
        (this.isAllowedDay(previousDay) && hour < endHour)
      );
    }

    return this.isAllowedDay(day);
  }

  updateStatus() {
    const onlineTexts = this.querySelectorAll("[data-contact-bar-online]");
    const offlineTexts = this.querySelectorAll("[data-contact-bar-offline]");
    const status = this.querySelector("[data-contact-bar-status]");

    if (!onlineTexts.length || !offlineTexts.length || !status) return;

    const available = this.isAvailable();
    onlineTexts.forEach((text) => {
      text.hidden = !available;
    });
    offlineTexts.forEach((text) => {
      text.hidden = available;
    });
    this.dataset.status = available ? "online" : "offline";

    const viewport = this.mobileMediaQuery.matches ? "mobile" : "desktop";
    const stateSelector = available ? "[data-contact-bar-online]" : "[data-contact-bar-offline]";
    const activeText = this.querySelector(`${stateSelector}[data-contact-bar-viewport="${viewport}"]`);
    status.setAttribute("aria-label", activeText?.textContent.trim() || "Kontakt aufnehmen");
  }
}

if (!customElements.get("cstm-announcement-contact-bar")) {
  customElements.define("cstm-announcement-contact-bar", CstmAnnouncementContactBar);
}
